export default () => ({
  context: {
    isStudent       : false,
    isPublisher     : false,
    isAdministrator : false
  },
  isLtiAccess   : false,
  isStudentMode : false
});
